// @ts-nocheck

const motives = {
  default: {
    menu: (provided) => ({
      ...provided,
      borderRadius: 0,
      marginTop: 3,
    }),
    option: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      backgroundColor: state.isSelected ? '#337ab7' : '#ffffff',
      cursor: 'pointer',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: 0,
      minHeight: 0,
      height: 36,
      fontSize: 12,
    }),
  },
  filter: {
    menu: (provided) => ({
      ...provided,
      borderRadius: 3,
      marginTop: 3,
      borderColor: '#5A5F64',
    }),
    menuList: (provided) => ({
      ...provided,
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#337ab7' : '#ffffff',
      cursor: 'pointer',
      borderColor: '#5A5F64',
      fontSize: 12,
      '&:hover': {
        backgroundColor: '#337ab7',
        color: '#ffffff',
      },
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: 3,
      borderColor: '#5A5F64',
      minHeight: 0,
      height: 36,
      fontSize: 12,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#5A5F64',
      cursor: 'pointer',
    }),
  },
  // Same shape as "default", except the focus border/glow and the selected-
  // option highlight are black instead of react-select's stock blue
  // (#2684FF focus glow, #337ab7 selected background) — added rather than
  // changed in "default" so every other Select in the app keeps its current
  // look; only SupportTicketWidget's priority field opts into this.
  supportTicket: {
    menu: (provided) => ({
      ...provided,
      borderRadius: 0,
      marginTop: 3,
    }),
    option: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      // "provided" carries react-select's own light-blue hover fill for
      // isFocused — replaced with '#960023' (theme's darkRed,
      // buttonMotives.ts's submitPrimary hover fill) so hovering an option
      // reads as an action, matching the Submit button's own color.
      // "isSelected" is checked FIRST (user feedback, 2026-09-24): react-
      // select auto-focuses the already-selected option when the menu first
      // opens, so that row is both isSelected AND isFocused at once — it
      // must stay gray (selected) rather than flash red (focused) in that
      // moment. Red only shows for a genuinely different, hovered row.
      backgroundColor: state.isSelected ? '#808080' : state.isFocused ? '#960023' : '#ffffff',
      color: state.isSelected || state.isFocused ? '#ffffff' : provided.color,
      cursor: 'pointer',
      fontSize: 12,
      // react-select's own default theme applies a light-blue ":active" fill
      // (mousedown/press) independently of the "isFocused" hover color set
      // above — not reachable through `state`, only by overriding the
      // pseudo-selector directly.
      '&:active': {
        backgroundColor: '#960023',
      },
    }),
    control: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      minHeight: 0,
      height: 36,
      fontSize: 12,
      borderColor: state.isFocused ? '#000000' : provided.borderColor,
      boxShadow: state.isFocused ? '0 0 0 1px #000000' : provided.boxShadow,
      '&:hover': {
        borderColor: '#000000',
      },
    }),
  },
  orderTable: {
    menu: (provided) => ({
      ...provided,
      borderRadius: 3,
      borderColor: '#5A5F64',
      overflow: 'visible',
      minWidth: 200,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#337ab7' : '#ffffff',
      cursor: 'pointer',
      overflow: 'visible',
      fontSize: 12,

      borderColor: '#5A5F64',
      '&:hover': {
        backgroundColor: '#337ab7',
        color: '#ffffff',
      },
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: 3,
      borderColor: '#5A5F64',
      minHeight: 0,
      overflow: 'visible',
      width: 55,
      fontSize: 12,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      overflow: 'visible',
      width: 55,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: 0,
    }),
    placeholder: (provided) => ({
      ...provided,
      width: 25,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
  },
};

export type SelectMotives = keyof typeof motives;

const pickMotive = (motive: SelectMotives) => motives[motive];

export { pickMotive };
